import { render, staticRenderFns } from "./CategoryChip.vue?vue&type=template&id=13f0b930&"
import script from "./CategoryChip.vue?vue&type=script&lang=js&"
export * from "./CategoryChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports